import { render } from "./Intro.vue?vue&type=template&id=04672cd5"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=04672cd5&lang=css"
script.render = render

export default script